import { BridgeMonitor } from './utils'

// 这里为移动端给H5发送的消息
// triggerWebViewLifecycleEvent 为页面展示和隐藏时，端上会发送消息
// 页面重新展现：onResume，页面隐藏：onPause

let triggerWebViewLifecycleEvent = {
  register: () => {},
  unregister: () => {},
  clear: () => {},
}

const initTriggerWebViewLifecycleEvent = () => {
  try {
    triggerWebViewLifecycleEvent = new BridgeMonitor('merchant', 'triggerLifecycle')
  } catch (err) {
    console.log(err)
  }
}

// export const

const PAGE_STATUS = {
  SHOW: 'onResume',
  HIDE: 'onPause',
}

export { PAGE_STATUS, initTriggerWebViewLifecycleEvent, triggerWebViewLifecycleEvent }
